import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

export const SignUpSuccessScreen: FunctionComponent = () => {
  return (
    <main className="login u">
      <div className="p-4">
        <div style={{ fontSize: 50, maxWidth: 600, color: 'white' }}>
          Your account has been created! You can now log in into the app.
        </div>
        <div className="flex justify-center">
          <Link to="/login" className="btn my-2" style={{ width: 'fit-content' }}>
            Login
          </Link>
        </div>
      </div>
    </main>
  );
};
